export default [
  {
    id: 1,
    name: 'Арсен',
    avatar: require('./assets/users/Arsen.svg'),
    synergy: [2],
  },
  {
    id: 2,
    name: 'Аня',
    avatar: require('./assets/users/Anya.svg'),
    synergy: [3, 4, 1],
  },
  {
    id: 3,
    name: 'Тёма',
    avatar: require('./assets/users/Tema.svg'),
    synergy: [2, 4],
  },
  {
    id: 4,
    name: 'Соня',
    avatar: require('./assets/users/Sonya.svg'),
    synergy: [2, 3],
  },
  {
    id: 5,
    name: 'Саша',
    avatar: require('./assets/users/Sasha.svg'),
    synergy: [6, 7, 8],
  },
  {
    id: 6,
    name: 'Запятыня',
    avatar: require('./assets/users/Zpt.svg'),
    synergy: [7, 5],
  },
  {
    id: 7,
    name: 'Скобец',
    avatar: require('./assets/users/Skb.svg'),
    synergy: [6, 5],
  },
  {
    id: 8,
    name: 'Ксюша',
    avatar: require('./assets/users/Ksusha.svg'),
    synergy: [5],
  },
]
